import { BrowserModule } from "@angular/platform-browser";
import { RouterModule, UrlSerializer, PreloadAllModules } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";

import { UrlSerializerService } from "./shared/providers/urlSerializer/url-serializer.service";
import { NotFoundComponent } from "./shared/components/not-found/not-found.component";
import { NgModule, PLATFORM_ID, APP_ID, Inject, APP_INITIALIZER } from "@angular/core";

import { SharedModule } from "./shared/shared.module";
import { AuthModule } from "./auth/auth.module";

import { routes } from "./app-routing";

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting

import { AppComponent } from "./app.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { HomeComponent } from './components/home/home.component';
import { AppConfigService } from './shared/providers/config.service';

import { BotDetectCaptchaModule } from 'angular-captcha';
import { AdminModule } from "./admin/admin.module";
import { ToastContainerModule, ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

@NgModule({
  declarations: [AppComponent, HomeComponent, NotFoundComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: "thiqah-ng-template" }),
    SharedModule.forRoot(),
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
    NgIdleKeepaliveModule.forRoot(),
    MomentModule, BotDetectCaptchaModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      progressBar: true,
      positionClass: 'toast-top-left',
      preventDuplicates: true,
    }),
    ToastContainerModule,
    AuthModule,
    AdminModule,
    ServiceWorkerModule.register("./ngsw-worker.js", {
      enabled: environment.production
    })
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },
    { provide: UrlSerializer, useClass: UrlSerializerService }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(APP_ID) private appId: string
  ) {
    const platform = isPlatformBrowser(platformId)
      ? "in the browser"
      : "on the server";
    console.log(`Running ${platform} with appId=${appId}`);
  }
}
